export default __webpack_public_path__ + "static/media/Ellipsis-1.4s-70px.1c34f788.svg";